/**
 * Auth-modal query-param contract (W3.1, auth-debt epic) — the ONE
 * vocabulary shared by the server auth middleware (which writes the params
 * on the protected-route redirect) and the client `AuthProvider` (which
 * reads them to open the modal and resume the original navigation). The
 * public app has NO login page — auth is modal-only — so an
 * unauthenticated hit on a protected route redirects to the locale home
 * carrying these params (the former target, `/login`, never existed and
 * landed users on the SPA catch-all).
 */

/** `?auth=1` — open the auth modal on load. */
export const AUTH_MODAL_PARAM = 'auth';
/** The only value the middleware writes / the provider honours. */
export const AUTH_MODAL_PARAM_VALUE = '1';
/**
 * `?redirect=<de-localized internal path>` — where to resume after
 * sign-in. The param is attacker-writable input: consumers MUST pass it
 * through the `@letsgethome/routes` `internalPath` door (same-app
 * absolute paths only), which makes an open redirect through the sign-in
 * flow unrepresentable.
 */
export const AUTH_REDIRECT_PARAM = 'redirect';
